export const DOCTORS = '/doctors'
